module.exports = __webpack_public_path__ + "img/elementlengths_jasa.e6577224.png";